import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';
import pdfAdd from '../assets/images/icone_add_pdf.png';

import { 
	getListaPedidoBase, alterarCarregamentoBase, getListaVeiculo
} from './pedidoActions';
import { 
	getLista as getListaBloqueioBase
} from '../bloqueioBase/bloqueioBaseActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import consts from '../consts';
import Camera from '../common/camera/camera';
import { setError } from '../common/toast/toast';

class PedidoBase extends Component {

	state = {
		linhaSelecionada: null,
		scrollY: -1
	}

    componentWillMount() {
		this.props.getListaPedidoBase();
		this.props.getListaVeiculo();
		this.props.getListaBloqueioBase();
		this.props.getListaPedidoPrazo();

		let idInterval = setInterval(() => {
			this.props.getListaPedidoBase();
			this.props.getListaVeiculo();
			this.props.getListaBloqueioBase();
			this.props.getListaPedidoPrazo();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {

        return (
            <div>
                <Content>
					
					<Aguardando aguardando={this.props.aguardando} />

					{this.lista()}
					
                </Content>
            </div>
        )
    }

	lista() {

		if (this.state.eventoTirarFoto) {
			
			if (this.state.scrollY == -1) {
				this.setState({
					...this.state,
					scrollY: window.scrollY
				});
			}

			return <Camera eventoFoto={this.state.eventoTirarFoto} />
		}

		if (this.state.scrollY > -1) {
			const scrollY = this.state.scrollY;
			setTimeout(() => {
				window.scrollTo(0, parseInt(scrollY));
			}, 20);

			this.setState({
				...this.state,
				scrollY: -1
			});
		}

		if (this.props.telaBloqueada) {
			return (
				<div class='alert alert-danger alert-dismissible'>
					<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>
					<h5><i class='icon fas fa-ban'></i> Base Bloqueada!</h5>
					Aguarde! A base está bloqueada pois passa por auditoria.
				</div>
			);
		}

		return (
			<>

				{this.eventoComponenteNumerico()}
				
				{!this.props.lista.length &&
				<p style={{ fontWeight: 'bold', textAlign: 'center', marginTop: 40 }}>Nenhuma viagem encontrada</p>}
				{this.props.lista.filter(item => {
					//Só lista uma viagem por vez
					if (this.props.lista.filter(itemAux => itemAux.datahora_inicio_carregamento).length && !item.datahora_inicio_carregamento) {
						return false;
					}
					return true;
				}).map(item => {

					let quantidadeTotal = 0;
					let quantidadeInformadaTotal = 0;
					
					if (item.datahora_inicio_carregamento) {						
						(item.itens || []).forEach(pedidoItem => {
							if (pedidoItem.id_produto == 1 || pedidoItem.id_produto == 3) {
								quantidadeTotal += parseFloat(pedidoItem.quantidade || 0);
							}
						});

						(item.carregamento_quantidade_medidor || []).forEach(compartimento => {
							quantidadeInformadaTotal += compartimento ? parseFloat(compartimento.valor || 0) : 0;
						});
					}

					return (
						<ContentCard key={item.id} style={{ backgroundColor: '#ffffff' }}>
							<ContentCardHeader>
								<Row>
									<Grid cols='6 6 6 6'>
										<strong>Giro:</strong>
									</Grid>
									<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
										<strong>Data/Hora Carga:</strong>
									</Grid>
								</Row>
								<Row>
									<Grid cols='6 6 6 6'>
										{item.giro}
									</Grid>
									<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
										{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrega || item.datahora_logistica)}
									</Grid>
								</Row>
								<Row>
									<Grid cols='6 6 6 6'>
										<strong>Placa:</strong>
									</Grid>
									<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
										<strong>Vendedor:</strong>
									</Grid>
								</Row>
								<Row>
									<Grid cols='6 6 6 6'>
										{item.placa_veiculo}
									</Grid>
									<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
										{item.nome_usuario_inclusao}
									</Grid>
								</Row>
								
								{item.datahora_inicio_carregamento &&
								<Row>
									{this.componenteImagem(
										'Foto do Calço:',
										item.carregamento_imagem_calco || [],
										(arquivos) => {
											this.props.alterarCarregamentoBase({
												...item,
												carregamento_imagem_calco: arquivos
											});
										}
									)}
								</Row>}
								{item.datahora_inicio_carregamento &&
								<Row>
									{this.componenteImagem(
										'Foto do Aterramento:',
										item.carregamento_imagem_terra || [],
										(arquivos) => {
											this.props.alterarCarregamentoBase({
												...item,
												carregamento_imagem_terra: arquivos
											});
										}
									)}
								</Row>}

								{item.datahora_inicio_carregamento &&
								<Row>
									{this.componenteImagem(
										'Foto da Boca:',
										item.carregamento_imagem_boca || [],
										(arquivos) => {
											this.props.alterarCarregamentoBase({
												...item,
												carregamento_imagem_boca: arquivos
											});
										}
									)}
								</Row>}

								{item.datahora_inicio_carregamento &&
								<Row>
									{this.componenteImagem(
										'Foto do Dreno:',
										item.carregamento_imagem_dreno || [],
										(arquivos) => {
											this.props.alterarCarregamentoBase({
												...item,
												carregamento_imagem_dreno: arquivos
											});
										}
									)}
								</Row>}
											
								<Row>
									{(item.itens || []).map((pedidoItem, i) => {

										const comprovantes = pedidoItem.imagem_nfe && pedidoItem.imagem_checklist;

										return (								
											<Grid cols='12 12 12 12' key={pedidoItem.id} style={{ marginTop: 4, marginBottom: 0}}>
												<div class='card' style={{ backgroundColor: comprovantes ? '#026625' : '#194682' }}>
													<div class='card-header' style={{ padding: 4 }}>
														<p style={{ fontWeight: 'bold', color: '#ffffff' }} class='card-title'>Entrega {i + 1}</p>
													</div>
													<div class='card-body' style={{ padding: 4, backgroundColor: comprovantes ? '#c1e3cd' : '#cbdef7' }}>
														<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Cliente:</b> {pedidoItem.nome_cliente}</p>
														<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Endereço:</b> {pedidoItem.nome_endereco}</p>
														<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Produto:</b> {pedidoItem.nome_produto}</p>
														<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Quantidade:</b> {FormatUtils.formatarValorTela(pedidoItem.quantidade, 2)}</p>
														{item.datahora_inicio_carregamento &&
														<>
															{/*<Row>
																{this.componenteImagem(
																	'Foto da Nota Fiscal:',
																	(item.carregamento_imagem_nf || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id),
																	(arquivos) => {
																		let arquivosAux = (item.carregamento_imagem_nf || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id).map(arquivo => arquivo);
																		
																		arquivos.forEach(arquivo => {
																			arquivosAux.push({
																				...arquivo,
																				id_pedido_item: pedidoItem.id
																			});
																		});

																		this.props.alterarCarregamentoBase({
																			...item,
																			carregamento_imagem_nf: arquivosAux
																		});
																	}
																)}
																</Row>*/}

															<Row>
																{this.componenteNumerico(
																	`Número da Nota Fiscal:`,
																	(item.carregamento_numero_nf || []).filter(registro => registro.id_pedido_item == pedidoItem.id)[0],
																	(valor) => {
																		let itensAux = (item.carregamento_numero_nf || []).filter(registro => registro.id_pedido_item != pedidoItem.id).map(registro => registro);
																		
																		if (pedidoItem.numero_nfe != FormatUtils.formatarValorBanco(valor)) {
																			window.alert(`Número da Nota Fiscal difere do informado no giro (${pedidoItem.numero_nfe || 'Não informado no giro'})`);
																		} else {
																			itensAux.push({
																				id_pedido_item: pedidoItem.id,
																				valor: FormatUtils.formatarValorBanco(valor)
																			});																			
																		}
																		this.props.alterarCarregamentoBase({
																			...item,
																			carregamento_numero_nf: itensAux
																		});
																	},
																	0 //Casas Decimais
																)}
															</Row>

															{(pedidoItem.compartimentos || []).map(comp => 
																<Row key={comp}>
																	
																	{!item.fob && //Só obriga imagem se não for FOB
																	this.componenteImagem(
																		`Foto do Lacre - Boca ${comp || '0'}:`,
																		(item.carregamento_imagem_lacre || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																		(arquivos) => {
																			let arquivosAux = (item.carregamento_imagem_lacre || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																			
																			arquivos.forEach(arquivo => {
																				arquivosAux.push({
																					...arquivo,
																					id_pedido_item: pedidoItem.id,
																					compartimento: comp
																				});
																			});

																			this.props.alterarCarregamentoBase({
																				...item,
																				carregamento_imagem_lacre: arquivosAux
																			});
																		}
																	)}															
																															
																	{!item.fob && //Só obriga imagem se não for FOB
																	this.componenteImagem(
																		`Foto da Seta - Boca ${comp || '0'}:`,
																		(item.carregamento_imagem_seta || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																		(arquivos) => {
																			let arquivosAux = (item.carregamento_imagem_seta || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																			
																			arquivos.forEach(arquivo => {
																				arquivosAux.push({
																					...arquivo,
																					id_pedido_item: pedidoItem.id,
																					compartimento: comp
																				});
																			});

																			this.props.alterarCarregamentoBase({
																				...item,
																				carregamento_imagem_seta: arquivosAux
																			});
																		}
																	)}

																	{/*this.componenteImagem(
																		`Foto Medidor Volumétrico - Boca ${comp || '0'}:`,
																		(item.carregamento_imagem_medidor || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																		(arquivos) => {
																			let arquivosAux = (item.carregamento_imagem_medidor || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																			
																			arquivos.forEach(arquivo => {
																				arquivosAux.push({
																					...arquivo,
																					id_pedido_item: pedidoItem.id,
																					compartimento: comp
																				});
																			});

																			this.props.alterarCarregamentoBase({
																				...item,
																				carregamento_imagem_medidor: arquivosAux
																			});
																		}
																	)*/}

																	{this.componenteNumerico(
																		`Quantidade Medidor Volumétrico - Boca ${comp || '0'}:`,
																		(item.carregamento_quantidade_medidor || []).filter(registro => registro.id_pedido_item == pedidoItem.id && registro.compartimento == comp)[0],
																		(valor) => {
																			let itensAux = (item.carregamento_quantidade_medidor || []).filter(registro => registro.id_pedido_item != pedidoItem.id || registro.compartimento != comp).map(registro => registro);
																			
																			itensAux.push({
																				id_pedido_item: pedidoItem.id,
																				compartimento: comp,
																				valor: valor
																			});

																			this.props.alterarCarregamentoBase({
																				...item,
																				carregamento_quantidade_medidor: itensAux
																			});
																		},
																		0 //Casas Decimais
																	)}
					
																</Row>
															)}
														</>}
													</div>
												</div>
											</Grid>
										);
									})}
								</Row>
							</ContentCardHeader>

							<ContentCardBody>
								{!item.datahora_inicio_carregamento ? (
									<Row alignCenter>
										<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
											<button 
												type='button'
												class='btn btn-block btn-success btn-lg'
												onClick={() => {
													if (window.confirm('Deseja realmente iniciar carregamento?')) {
														this.props.alterarCarregamentoBase({
															...item,
															datahora_inicio_carregamento: DateFormat.getDataHoraAtual(),
															id_usuario_carregamento: this.props.sessao.id
														});
													}
												}}>
												Iniciar Carregamento
											</button>
										</Grid>
									</Row>
								) : (
									<div>
										<Row>
											<Grid cols='6 6 6 6'>
												<strong>Início do Carregamento:</strong>
											</Grid>
										</Row>
										<Row>
											<Grid cols='6 6 6 6'>
												{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio_carregamento)}
											</Grid>
										</Row>
										{!item.datahora_fim_carregamento &&
										<>
										<Grid cols='12 12 6 6' style={{ maxWidth: 350 }}>

	<div style={{
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '6px 0',
		borderBottom: '1px solid #eee'
	}}>
		<strong>Quantidade Total:</strong>
		<span>
			{FormatUtils.formatarValorTelaDecimal(quantidadeTotal, 0)} L
		</span>
	</div>

	<div style={{
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '6px 0',
		borderBottom: '1px solid #eee'
	}}>
		<strong>Quantidade Carregada:</strong>
		<span>
			{FormatUtils.formatarValorTelaDecimal(quantidadeInformadaTotal, 0)} L
		</span>
	</div>

	<div style={{
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '6px 0',
		fontWeight: 'bold',
		color: (quantidadeTotal - quantidadeInformadaTotal) === 0
			? '#28a745'
			: '#dc3545'
	}}>
		<span>Diferença:</span>
		<span>
			{FormatUtils.formatarValorTelaDecimal(
				quantidadeTotal - quantidadeInformadaTotal,
				0
			)} L
		</span>
	</div>

</Grid>
										</>}					
									</div>
								)}
								
								{(item.datahora_inicio_carregamento && !item.datahora_fim_carregamento) ? (
									<Row alignCenter style={{ marginTop: 16 }}>
										<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
											<button 
												type='button'
												class='btn btn-block btn-danger btn-lg'
												onClick={() => {
													if (window.confirm('Deseja realmente desfazer o início do carregamento?')) {
														this.props.alterarCarregamentoBase({
															...item,
															datahora_inicio_carregamento: null
														});
													}
												}}>
												Desfazer Início do Carregamento
											</button>
										</Grid>
										<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
											<button 
												type='button'
												class='btn btn-block btn-success btn-lg'
												onClick={() => {
													if (window.confirm('Deseja realmente finalizar carregamento?')) {
														this.props.alterarCarregamentoBase({
															...item,
															datahora_fim_carregamento: DateFormat.getDataHoraAtual(),
															id_usuario_entrega: this.props.sessao.id,
															datahora_entrega: DateFormat.getDataHoraAtual()
														});
													}
												}}>
												Finalizar Carregamento
											</button>
										</Grid>
									</Row>
								) : (item.datahora_fim_carregamento ? (
									<div>
										<Row>
											<Grid cols='6 6 6 6'>
												<strong>Fim do Carregamento:</strong>
											</Grid>
										</Row>
										<Row>
											<Grid cols='6 6 6 6'>
												{DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim_carregamento)}
											</Grid>
										</Row>
										<br />
										<Row alignCenter>
											<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
												<button 
													type='button'
													class='btn btn-block btn-danger btn-lg'
													onClick={() => {
														if (window.confirm('Deseja realmente reabrir o carregamento?')) {
															this.props.alterarCarregamentoBase({
																...item,
																datahora_fim_carregamento: null
															});
														}
													}}>
													Reabrir Carregamento
												</button>
											</Grid>
										</Row>
									</div>
								) : null)}
								
							</ContentCardBody>
						</ContentCard>
					);
				})}
			</>
		);
    }

	componenteImagem(nome, arquivos, evento) {

		return (
				<Grid cols='12 12 12 12'>
					<Row style={{ paddingBottom: 8 }}>
						<Grid cols='12 12 12 12'>
							<label>{nome} <i class={(arquivos || []).length ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: (arquivos || []).length ? '#00a13b' : '#ff0000' }}></i></label>
						</Grid>
						{(arquivos || []).map(arquivo => (
							<div key={arquivo.id} style={{ marginLeft: 8, display: 'flex', flexDirection: 'column' }}>
								<span class="btn btn-outline-primary fileinput-button dz-clickable">
									<img src={arquivo.arquivo_base64 ? arquivo.arquivo_base64 : (arquivo.file ? `${consts.URL}/${arquivo.file}` : pdfAdd)} style={{ height: 30 }} />
								</span>
								<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
									<button
										type='button'
										class='btn btn-flat btn-outline-primary'
										style={{ width: '48%' }}
										disabled={arquivo.arquivo_base64 ? true : false}
										onClick={() => {
											window.open(`${consts.URL}/${arquivo.file}`, '_blank');
										}}>
										<i class='fas fa-download'></i>
									</button>
									<button
										type='button'
										class='btn btn-flat btn-outline-danger'
										style={{ width: '48%' }}
										onClick={() => {
											evento(arquivos.filter(item => item.id != arquivo.id));
										}}>
										<i class='fas fa-trash-alt'></i>
									</button>
								</div>
							</div>
						))}
						
						<a class={`btn btn-app bg-success`}
							onClick={() => {
								this.setState({
									...this.state,
									eventoTirarFoto: (result) => {
										let lista = (arquivos || []).map(item => item);
										lista.push({
											id: new Date().getTime(),
											arquivo_base64: result
										});
										evento(lista);
										this.setState({
											...this.state,
											eventoTirarFoto: null
										});
									}
								});
							}}>
							<i class='fas fa-camera'></i> Câmera
						</a>
					</Row>
				</Grid>
		);
	}

	componenteNumerico(nome, registro, evento, casasDecimais) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={registro && parseFloat(registro.valor || 0) > 0.0  ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: registro && parseFloat(registro.valor || 0) > 0.0 ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					<button 
						type='button'
						class='btn btn-block btn-outline-dark btn-flat'
						style={{ maxWidth: 200 }}
						onClick={() => {
							this.setState({
								...this.state,
								casasComponenteNumerico: casasDecimais || 0,
								valorComponenteNumerico: registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : '',
								eventoComponenteNumerico: (result) => {
									evento(result);
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}
							});
						}}>
						{registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : FormatUtils.formatarValorTela(0, casasDecimais)}
					</button>
				</Row>
			</Grid>
		);
	}

	eventoComponenteNumerico() {
		if (!this.state.eventoComponenteNumerico) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' 
								onClick={() => {
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row>
								<LabelAndInputNumber
									label='Informe' 
									placeholder='Informe'
									cols='12 12 12 12'
									casas={this.state.casasComponenteNumerico}
									value={this.state.valorComponenteNumerico}
									onChange={data => {
										this.setState({
											valorComponenteNumerico: data.target.value
										});
									}} />
							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {
									this.state.eventoComponenteNumerico(
										parseFloat(FormatUtils.formatarValorBanco(this.state.valorComponenteNumerico, this.state.casasComponenteNumerico))
									);
								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
	}
	
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pedido.aguardando,
	modoTela: state.pedido.modoTela,
	lista: state.pedido.listaPedidoBase.filter(item => {
		if (!state.auth.usuarioCarregado) {
			return false;
		} else if (state.auth.usuarioCarregado.id_unidade) {
			return item.id_unidade == state.auth.usuarioCarregado.id_unidade;
		} else {
			return true;
		}
	}).filter(item => {
		if (item.datahora_inicio_carregamento && item.id_usuario_carregamento != state.auth.usuarioCarregado.id) {
			return false;
		}

		return true;
	}),
	listaVeiculo: state.pedido.listaVeiculo,
	listaBloqueada: state.bloqueioBase.listaBloqueada,
	telaBloqueada: state.auth.usuarioCarregado 
		&& state.bloqueioBase.listaBloqueada.filter(item => !state.auth.usuarioCarregado.id_unidade || item.id_unidade == state.auth.usuarioCarregado.id_unidade).length
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	getListaPedidoBase, alterarCarregamentoBase, getListaVeiculo, getListaBloqueioBase, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoBase);
